export const AvailableLanguages = [
	{ name: 'English', lang: 'en', icon: null, dir: 'ltr' },
	{ name: 'العربية', lang: 'ar', icon: null, dir: 'rtl' },
];
